import { makeStyles } from '@material-ui/core';
import { themeColors } from '@ncr-retail/mui-theme';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(theme => ({
  container: {
    marginLeft: '5%',
    justifyContent: 'center',
  },
  title: {
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    fontSize: rem(2),
    marginBlockStart: '0',
    marginBlockEnd: '.5em',
    padding: '0 5%',
    letterSpacing: '0.2px',
    color: themeColor.defaultTextColor,
  },
  message: {
    paddingTop: '1.5em',
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: rem(1.125),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    whiteSpace: 'pre-wrap',
  },
  padding: {
    '@media (max-width: 1920px) ': {
      paddingLeft: '22%',
    },
    '@media (max-width: 1600px) ': {
      paddingLeft: '17%',
    },
    '@media (max-width: 1366px) ': {
      paddingLeft: '11%',
    },
    '@media (max-width: 1280px) ': {
      paddingLeft: '9%',
    },
    '@media (max-width: 1024px) ': {
      paddingLeft: '3%',
    },
  },
  paddingPriceEntry: {
    '@media (max-width: 1920px) ': {
      paddingLeft: '21%',
    },
    '@media (max-width: 1600px) ': {
      paddingLeft: '15%',
    },
    '@media (max-width: 1366px) ': {
      paddingLeft: '10%',
    },
    '@media (max-width: 1280px) ': {
      paddingLeft: '7%',
    },
    '@media (max-width: 1024px) ': {
      paddingLeft: '3%',
    },
    '@media  (width: 1024px) and (height: 768px)': {
      paddingLeft: '9%',
    },
    '@media  (width: 1600px) and (height: 1200px)': {
      paddingLeft: '23%',
    },
  },
  verifyTitle: {
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    fontSize: rem(2),
    marginBlockStart: '0',
    marginBlockEnd: '.5em',
    padding: '0 5%',
    letterSpacing: '0.2px',
    color: themeColor.defaultTextColor,
  },
  subMessage: {
    marginBlockStart: '0',
    marginBlockEnd: '2em',
  },
  header: {
    backgroundColor: themeColor.white,
    height: '7.29vh',
    '@media (aspect-ratio: 4/3)': {
      height: '5.76vh',
    },
    fontSize: rem(1.125),
    boxShadow: `0px 1px 2px ${themeColor.borderGray}`,
  },
  icon: {
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  warning: {
    color: themeColor.alert,
  },
  contentContainer: {
    height: '100%',
    padding: '2.70vh 2.34vw 4.24vh',
    paddingTop: '3em',
    '@media (max-width: 1024px) and (max-height: 576px)': {
      paddingTop: '1.5em',
    },
    paddingBottom: '3em',
  },
  rejectButton: {
    marginRight: '1.7vw',
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '24px',
  },
  acceptButton: {
    background: theme.palette.primary.main,
    color: 'white',
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '24px',
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  keyPadContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    paddingBottom: '3em',
  },
  subBarText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1.125),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: '#5D6B72',
    marginTop: '-.5em',
  },
  contentItemNameSubText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1.25),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: themeColors.palesky,
    paddingBottom: '10px',
  },
  contentItemCodeSubText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: '#5D6B72',
    paddingBottom: '10px',
  },
  currencyText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: rem(1.25),
    lineHeight: '23px',
    alignItems: 'center',
    textAlign: 'right',
    letterSpacing: '0.0025em',
    color: themeColor.defaultTextColor,
  },
}));
